import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Tracker } from './tracker';

/** Dispara $pageview a cada mudanca de rota no SPA. */
export function usePageTracking(): void {
  const location = useLocation();

  useEffect(() => {
    Tracker.screen(location.pathname);
  }, [location.pathname]);
}
